'use client';

import { useEffect, useRef } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { useAnalytics } from '@/hooks/useAnalytics';

function inIframe(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.self !== window.top;
  } catch {
    // Cross-origin access can throw; treat as embedded.
    return true;
  }
}

export function MarketingQueryTracking() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const analytics = useAnalytics();
  const lastUrlRef = useRef<string | null>(null);

  useEffect(() => {
    if (!pathname) return;
    if (typeof window === 'undefined') return;
    if (inIframe()) return;

    const search = searchParams?.toString() ?? '';
    const url = search ? `${pathname}?${search}` : pathname;

    // Guard against StrictMode double-effects and rerenders without URL change.
    if (lastUrlRef.current === url) return;
    lastUrlRef.current = url;

    const utmCampaign = searchParams?.get('utm_campaign') ?? '';
    const emailSource = searchParams?.get('email_source') ?? '';

    // Sticky de-dupe across navigations within the same tab.
    // Prevents spamming Segment if user navigates around with the same query params.
    const seen = (key: string) => {
      try {
        return window.sessionStorage.getItem(key) === '1';
      } catch {
        return false;
      }
    };
    const markSeen = (key: string) => {
      try {
        window.sessionStorage.setItem(key, '1');
      } catch {
        // ignore
      }
    };

    if (utmCampaign.length) {
      analytics.track(utmCampaign as any, {} as any);
      // const key = `mk:utm_campaign:${utmCampaign}`;
      // if (!seen(key)) {
      //   markSeen(key);
      //   // Legacy behavior: event name = utm_campaign value.
      //   analytics.track(utmCampaign as any, {} as any);
      // }
    }

    if (emailSource.length) {
      // const key = `mk:email_source:${emailSource}`;
      analytics.track('loaded_from_email' as any, { email_source: emailSource } as any);
      // if (!seen(key)) {
      //   markSeen(key);
      //   analytics.track('loaded_from_email' as any, { email_source: emailSource } as any);
      // }
    }
  }, [analytics, pathname, searchParams]);

  return null;
}
